import "./App.css";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import HomePage from "./components/HomePage";
import RetirementPlanning from "./components/RetirementPlanning";
import FinancialAdvisor from "./components/FinancialAdvisor";
import WealthManagement from "./components/WealthManagement";
import ContactPage from "./components/ContactPage";
import ThankYouPage from "./components/ThankYouPage";
import AboutPage from "./components/AboutPage";
import { Toaster } from "./components/ui/sonner";

function App() {
  return (
    <div className="App">
      <BrowserRouter>
        <Routes>
          <Route path="/" element={<HomePage />} />
          <Route path="/about" element={<AboutPage />} />
          <Route path="/retirement-planning" element={<RetirementPlanning />} />
          <Route path="/financial-advisor" element={<FinancialAdvisor />} />
          <Route path="/wealth-management" element={<WealthManagement />} />
          <Route path="/contact" element={<ContactPage />} />
          <Route path="/thank-you" element={<ThankYouPage />} />
        </Routes>
      </BrowserRouter>
      <Toaster />
    </div>
  );
}

export default App;